
import AudioQueue from '@/assets/js/audio/queue.js'

const audioUrlMap = {
    '0': '/message_order_tips.mp3',
    '1': '/return_groods_tips.mp3',
    '2': '/enterprise_approval_tips.mp3',
    '3': '/picking_order_tips.mp3'
}

export default class AudioScope {
    constructor(el) {
        this.audioRef = el
        this.audioQueue = new AudioQueue()
    }

    init(data) {
        const isEmpty = this.audioQueue.isEmpty
        const messageList = data.map(item => this.asyncAudio(item))
        this.audioQueue.add(...messageList)
        if (isEmpty) this.audioQueue.run()
    }

    /* 创建语音播报任务 */
    asyncAudio(item) {
        return async (next) => {
            try {
                const url = `${this.getApi}${audioUrlMap[item.notify_type]}`
                await this.ended(url)
                next.call(this.audioQueue)
            }
            catch (error) {
                throw Error(error)
            }
        }
    }

    /* 语音播放 */
    ended(url) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                this.audioRef.src = url
                this.audioRef.muted = false
                this.audioRef.play().catch(_error => {
                    reject('需要用户有交互才有语音提示哦')
                })
                this.audioRef.addEventListener('ended', () => {
                    resolve('正常语音播放')
                }, false)
            })
        })
    }

    get getApi() {
        return location.origin.indexOf('localhost') !== -1 ? '/static' : '/warehouse_apply_front/static'
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/audio/scope.js